import { render, staticRenderFns } from "./ModalCustom.vue?vue&type=template&id=cedcf398&scoped=true&"
import script from "./ModalCustom.vue?vue&type=script&lang=js&"
export * from "./ModalCustom.vue?vue&type=script&lang=js&"
import style0 from "./ModalCustom.vue?vue&type=style&index=0&id=cedcf398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedcf398",
  null
  
)

export default component.exports